import { Tag } from "./Tag";

import type { TagProps } from "./Tag";

export interface TagListProps {
  tags: TagProps[];
}

export function TagList({ tags }: TagListProps) {
  return (
    <div className="TagList">
      {tags.map(({ color, children, blend, text, icon, iconVariant }) => (
        <Tag
          key={text}
          color={color}
          blend={blend}
          icon={icon}
          iconVariant={iconVariant}
        >
          {children}
          {text}
        </Tag>
      ))}
    </div>
  );
}
